import { RevisedTraumaScoreConstants } from './revisedTraumaScore.constants'
import { IRevisedTraumaScoreState, IRevisedTraumaScoreAction } from './revisedTraumaScore.types'

export const initialRevisedTraumaScoreState: IRevisedTraumaScoreState = {
  rtsBp: null,
  rtsResp: null,
  rts: null,
}

export function revisedTraumaScoreReducer(
  state: IRevisedTraumaScoreState = initialRevisedTraumaScoreState,
  action: IRevisedTraumaScoreAction
): IRevisedTraumaScoreState {
  switch (action.type) {
    case RevisedTraumaScoreConstants.SET_RTS_BP:
      return { ...state, rtsBp: action.rtsBp }
    case RevisedTraumaScoreConstants.SET_RTS_RESP:
      return { ...state, rtsResp: action.rtsResp }
    case RevisedTraumaScoreConstants.SET_RTS:
      return { ...state, rts: action.rts }
    case RevisedTraumaScoreConstants.SET_RTS_DATA:
      return { ...state, ...action.rtsData }
    case RevisedTraumaScoreConstants.RESET_RTS_DATA:
      return { ...initialRevisedTraumaScoreState }
    default:
      return state
  }
}
